export function HEX2RGB (hex) {
    // Legacy rows may carry no color at all; a missing value must not
    // break the rendering of the whole page. Fall back to black.
    if (!hex) { return [ 0, 0, 0, 1 ]; }
    if (hex.charAt(0) === '#') {
        hex = hex.substr(1);
    }
    if ((hex.length < 2) || (hex.length > 8)) {
        return false;
    }
    var values = hex.split(''),
        r,
        g,
        b;

    let a = 1;
    if (hex.length === 2) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = r;
        b = r;
    } else if (hex.length === 3) {
        r = parseInt(values[0].toString() + values[0].toString(), 16);
        g = parseInt(values[1].toString() + values[1].toString(), 16);
        b = parseInt(values[2].toString() + values[2].toString(), 16);
    } else if (hex.length === 6) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = parseInt(values[2].toString() + values[3].toString(), 16);
        b = parseInt(values[4].toString() + values[5].toString(), 16);
    } else if (hex.length === 8) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = parseInt(values[2].toString() + values[3].toString(), 16);
        b = parseInt(values[4].toString() + values[5].toString(), 16);
        a = parseInt(values[6].toString() + values[7].toString(), 16) / 255;
    } else {
        return false;
    }
    return [r, g, b, a];
}

/**
 * Returns "black" or "white", whichever reads better on the given
 * background color (WCAG relative luminance).
 */
export function textColorForBackground (hex) {
    const rgb = HEX2RGB(hex);
    if (!rgb) { return 'black'; }
    const channel = (c) => {
        c /= 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    const luminance = 0.2126 * channel(rgb[0])
                    + 0.7152 * channel(rgb[1])
                    + 0.0722 * channel(rgb[2]);
    return luminance > 0.179 ? 'black' : 'white';
}

/**
 * This file is for converting hex colors
 * @param hexColor
 * @returns {string}
 */

export const getComplementaryHexColor = (hexColor) => {
	// Legacy rows may carry no color at all; a missing value must not
	// break the rendering of the whole page.
	if (!hexColor) return "#FFFFFF"
	const colorMap = {
		"0": "F",
		"1": "E",
		"2": "D",
		"3": "C",
		"4": "B",
		"5": "A",
		"6": "9",
		"7": "8",
		"8": "7",
		"9": "6",
		"A": "5",
		"B": "4",
		"C": "3",
		"D": "2",
		"E": "1",
		"F": "0"
	}
	const hexEntries = hexColor.split("")
	let complHexString = "#"
	hexEntries.shift()
	for (const entry of hexEntries) {
		complHexString += colorMap[entry]
	}
	return complHexString
}

export function hslToHex(h, s, l) {
	l /= 100;
	const a = s * Math.min(l, 1 - l) / 100;
	const f = n => {
		const k = (n + h / 30) % 12;
		const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
		return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
	};
	return `#${f(0)}${f(8)}${f(4)}`;
}
